import actionTypes from '../actionTypes';
import moment from 'moment';

export function updateTournamentChat(data, chatStatus) {
  return {
    type: actionTypes.TOURNAMENT_CHAT_UPDATE,
    tournamentId: data.tournamentId,
    value: {
      tournamentId: data.tournamentId,
      text: data.message,
      username: data.username,
      on: moment(data.sendDate).valueOf(),
      self: data.self,
    },
    chatStatus: chatStatus,
    now: moment().valueOf(),
  };
}

export function openTournamentChat(data) {
  return {
    type: actionTypes.OPEN_TOURNAMENT_CHAT,
    tournamentId: data.tournamentId,
    now: moment().valueOf(),
    chatStatus: true,
  };
}

export function closeTournamentChat(data) {
  return {
    type: actionTypes.CLOSE_TOURNAMENT_CHAT,
    tournamentId: data.tournamentId,
    now: moment().valueOf(),
    chatStatus: true,
  };
}